import React from "react";
import { isMobile } from "react-device-detect";
import { Link, useLocation } from "react-router-dom";
import "./AuthMenu.scss";
import AppContext from "../AppContext";

const RadialProgress = React.forwardRef(function RadialProgress({ icon, label, progress, color }, ref) {
  const rotation = progress * 360;
  const isGreen = color === 'green';
  const ringImg = isGreen ? '/slot/Round%20out%20green.png' : '/slot/Round%20out%20yellow.png';
  const glowImg = isGreen ? '/slot/Round%20out%20green%20light.png' : '/slot/Round%20out%20yellow%20light.png';

  return (
    <div className="radial-progress" ref={ref}>
      <img src="/slot/Round%20back.png" alt="" className="radial-progress__bg" />
      <img src={ringImg} alt="" className="radial-progress__ring" />
      <div
        className="radial-progress__glow-wrap"
        style={{
          background: `conic-gradient(transparent 0deg, transparent 0deg, white ${rotation}deg, transparent ${rotation}deg)`,
          WebkitMaskImage: `url(${glowImg})`,
          maskImage: `url(${glowImg})`,
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
        }}
      >
        <img src={glowImg} alt="" className="radial-progress__glow" />
      </div>
      <img src={icon} alt="" className="radial-progress__icon" />
      <span className="radial-progress__label">{label}</span>
    </div>
  );
});

function AuthMenu() {
  const {
    toggleFullscreen, slotAnimationTargetRef,
    slotCrystalTargetRef, slotFSTargetRef,
    isRegistered, slotBalance, crystalCount,
  } = React.useContext(AppContext);
  const location = useLocation();
  const path = location.pathname;
  if (path === "/signup") {
    return null;
  }

  if (isRegistered) {
    return (
      <div className={`auth-menu auth-menu--logged ${isMobile ? "mobile" : "desktop"}`} ref={slotAnimationTargetRef}>
        <div className="auth-menu__progress-group">
          <RadialProgress
            ref={slotCrystalTargetRef}
            icon="/slot/Crystal.png"
            label={`x${crystalCount}`}
            progress={Math.min(crystalCount / 30, 1)}
            color="green"
          />
          <RadialProgress
            ref={slotFSTargetRef}
            icon="/slot/FS.png"
            label="x30"
            progress={0.75}
            color="yellow"
          />
        </div>
        <div className="auth-menu__balance">
          <span className="auth-menu__balance-text">&euro; {slotBalance.toFixed(2)}</span>
          <img src="/slot/Wallet.png" alt="Wallet" className="auth-menu__wallet-icon" />
        </div>
        <button className="auth-menu__deposit-btn">Deposit</button>
      </div>
    );
  }

  return (
    <div className={`auth-menu ${isMobile ? "mobile" : "desktop"}`} ref={slotAnimationTargetRef}>
      <a onClick={toggleFullscreen}>
        <img src='/btn-login.png' alt='Icon 1' className='nav-icon' />
      </a>
      <Link to='/signup'>
        <img src='/btn-signup.png' alt='Icon 2' className='nav-icon' />
      </Link>
    </div>
  );
}

export default AuthMenu;
